import { render, staticRenderFns } from "./policySearchDetail.vue?vue&type=template&id=34dd1538&scoped=true"
import script from "./policySearchDetail.vue?vue&type=script&lang=js"
export * from "./policySearchDetail.vue?vue&type=script&lang=js"
import style0 from "./policySearchDetail.vue?vue&type=style&index=0&id=34dd1538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dd1538",
  null
  
)

export default component.exports